import * as React from "react"
import Card from "../../blocks/card/Card"
import Icon from "../../blocks/icon/Icon"
import * as classNames from "./CtxArticleHeaderSection.module.scss"
import CtxHeroSection from "../ctx-hero-section/CtxHeroSection"
import { formatDate } from "../../../../../utils/formatDate"
import ShareBlock from "../../blocks/shareBlock/ShareBlock"
import Button from "../../blocks/button/Button"

const CtxArticleHeaderSection = ({
  image,
  title,
  imageUrl,
  imageAlt,
  publishDate,
  pageContext,
}) => {
  const url = typeof window !== "undefined" ? window.location.href : ""
  const pdfFile =
    pageContext.itemData.attributes?.pdfDeCommunique?.data?.attributes.url
  const pdfUrl = pageContext.itemData?.attributes?.urlPdfDeCommunique
  return (
    <CtxHeroSection
      image={image}
      imgSrc={imageUrl}
      imgAlt={imageAlt}
      classes="mb-5"
    >
      <div className={`${classNames.article_header} fade-in-bottom`}>
        <Card className="container card_bottom flex flex-direction-column justify-content-end align-items-center text-center pbl-6 pin-3">
          <h1>{title}</h1>
          <div
            className={`flex flex-direction-column md-flex-direction-row align-items-center ${classNames.article_metas}`}
          >
            <div className={classNames.article_meta}>
              <Icon
                icon="calendar"
                width="16"
                height="16"
                color="var(--gris)"
              />
              <span className="quartary-text-color">
                {formatDate(publishDate)}
              </span>{" "}
              <span className="hidden md-flex">|</span>
            </div>
            <div className={classNames.article_meta}>
              <ShareBlock url={url} />
            </div>
            {pdfFile || pdfUrl ? (
              <div>
                <Button
                  aspect="contrastant"
                  size="small"
                  color="primary"
                  to={
                    pageContext.itemData.attributes.pdfDeCommunique.data
                      ? pdfFile
                      : pdfUrl
                  }
                  target="_blank"
                  className={"fluid"}
                >
                  Télécharger le communiqué
                </Button>
              </div>
            ) : null}
          </div>
        </Card>
      </div>
    </CtxHeroSection>
  )
}

export const name = "CtxArticleHeaderSection"

export const init = (componentData, pageContext) => {
  // console.log(JSON.stringify(pageContext,undefined,2))
  return (
    <CtxArticleHeaderSection
      key={componentData.id}
      pageContext={pageContext}
      title={
        pageContext.itemData.attributes.label ||
        pageContext.itemData.attributes.title
      }
      image={pageContext.itemData.attributes.image.data?.attributes}
      //url from article or category or parent category
      imageUrl={
        pageContext.itemData.attributes.image.data?.attributes.url ||
        pageContext.itemData.attributes.category?.data?.attributes
          .defaultArticleHeaderImage.data?.attributes.url ||
        pageContext.itemData.attributes.category?.data?.attributes
          .defaultArticleHeaderImage.data?.attributes.parent.data?.attributes
          .defaultArticleHeaderImage.data?.attributes.url
      }
      publishDate={
        pageContext.itemData.attributes.publishedAt ||
        pageContext.itemData.attributes.date
      }
    />
  )
}

export default CtxArticleHeaderSection
